import { aplicarPorcentaje } from '../dinero';

/** Regla de comisión: porcentaje guardado ×100 (3000 = 30 %) o monto fijo en centavos por unidad. */
export interface ReglaComision {
  tipo: 'porcentaje' | 'fijo';
  valor: number;
}

/** Comisión de una línea de venta; nunca mayor que el total de la línea. */
export function comisionLinea(linea: { total: number; cantidad: number }, regla: ReglaComision | null | undefined): number {
  if (!regla || regla.valor <= 0 || linea.total <= 0) return 0;
  const monto = regla.tipo === 'porcentaje' ? aplicarPorcentaje(linea.total, regla.valor / 100) : regla.valor * linea.cantidad;
  return Math.min(monto, linea.total);
}
